import { DateTime } from 'luxon';
import {
  IModel,
  Model,
  IEstimateSalesItemModel,
  EstimateSalesItemModel,
} from '.';

export interface IEstimateModel extends IModel {
  estimateId: number;
  petId: number;
  clinicId: number;
  name: string;
  dateCreated: string;
  redeemedDate: string | undefined;
  estimateSalesItems: IEstimateSalesItemModel[];
  salesPackageId: number | undefined;
  salesPackageName: string | undefined;
  salesPackagePrice: number | undefined;
}

export class EstimateModel
  extends Model
  implements Record<keyof IEstimateModel, any>
{
  estimateId: number;
  petId: number;
  clinicId: number;
  name: string;
  dateCreated: DateTime;
  redeemedDate: DateTime | undefined;
  estimateSalesItems: EstimateSalesItemModel[];
  salesPackageId: number | undefined;
  salesPackageName: string | undefined;
  salesPackagePrice: number | undefined;

  constructor(params: IEstimateModel) {
    super(params);
    this.estimateId = params.estimateId;
    this.petId = params.petId;
    this.clinicId = params.clinicId;
    this.name = params.name;
    this.dateCreated = DateTime.fromISO(params.dateCreated, { zone: 'utc' });
    this.redeemedDate = params.redeemedDate
      ? DateTime.fromISO(params.redeemedDate, { zone: 'utc' })
      : undefined;
    this.estimateSalesItems = (params.estimateSalesItems ?? []).map(
      (esi) => new EstimateSalesItemModel(esi),
    );
    this.salesPackageId = params.salesPackageId;
    this.salesPackageName = params.salesPackageName;
    this.salesPackagePrice = params.salesPackagePrice;
  }
}
